import { $session } from "./session";

export const $hasSession = $session.map(
  (state) => state.accessToken !== undefined,
);
